import React from 'react';
import './HizmetCard.css';
import { FaWrench, FaCar, FaOilCan, FaCircle, FaBolt, FaSnowflake } from 'react-icons/fa';

const iconMap = {
  engine: FaCar,
  brake: FaCircle,
  oil: FaOilCan,
  tire: FaCircle,
  electric: FaBolt,
  ac: FaSnowflake,
  wrench: FaWrench,
};

const HizmetCard = ({ hizmet }) => {
  const Icon = iconMap[hizmet.ikon] || FaWrench;

  return (
    <div className="hizmet-card">
      <div className="hizmet-icon">
        <Icon />
      </div>
      <h3>{hizmet.baslik}</h3>
      <p>{hizmet.aciklama}</p>
    </div>
  );
};

export default HizmetCard;
